// stop-swatch-mobile-redirect.js
// Defensive mobile-only interceptor for Dawn swatches.
// Paste this file into assets and include it before </body> as described.

(function () {
  const DEBUG = false;

  function isMobile() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  // Build srcset like your original logic
  function buildSrcset(imageUrl) {
    const sizes = [165, 360, 533, 720, 940, 1066];
    try {
      return sizes.map(size => {
        const sizeUrl = imageUrl.replace(/width=\d+/, `width=${size}`);
        return `${sizeUrl} ${size}w`;
      }).join(', ');
    } catch (err) {
      return '';
    }
  }

  // Swap the card image (safe defensive routine)
  function swapCardImage(card, imageUrl) {
    if (!card || !imageUrl) return;
    const productImage = card.querySelector('.card__media img') || card.querySelector('img');
    if (!productImage) return;

    const srcset = buildSrcset(imageUrl);
    const sizesAttr = "(min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)";

    const preloader = new Image();
    preloader.srcset = srcset;
    preloader.sizes = sizesAttr;
    preloader.src = imageUrl;

    preloader.onload = function () {
      try {
        if (srcset) productImage.srcset = srcset;
        productImage.sizes = preloader.sizes;
        productImage.src = imageUrl;
        if (DEBUG) console.log('swapCardImage: swapped to', imageUrl, card);
      } catch (err) {
        if (DEBUG) console.error('swapCardImage error', err);
      }
    };

    preloader.onerror = function () {
      if (DEBUG) console.error('swapCardImage preload failed for', imageUrl);
    };
  }

  // When a swatch is tapped, mark the parent card briefly so card click handlers can check the flag
  function markCardTapped(card) {
    try {
      if (!card) return;
      card.dataset._swatchTapped = 'true';
      setTimeout(() => {
        try { delete card.dataset._swatchTapped; } catch (e) {}
      }, 400);
    } catch (e) {}
  }

  // Early capture-phase pointer/touchstart handler to prevent navigation on mobile
  function onPointerStartCapture(e) {
    try {
      if (!isMobile()) return;
      const swatch = e.target && e.target.closest ? e.target.closest('.color-swatch') : null;
      if (!swatch) return;

      // Prevent default browser navigation behavior on mobile (touchend->click sequence)
      // Use preventDefault on the earliest event available (pointerdown/touchstart)
      if (e.cancelable) {
        try { e.preventDefault(); } catch (err) {}
      }

      // Stop other listeners from executing for this event
      try { e.stopImmediatePropagation(); } catch (err) {}

      const card = swatch.closest('.card-wrapper') || swatch.closest('.card__inner') || swatch.closest('.card');
      markCardTapped(card);

      // try to obtain image URL from dataset (fallback to href)
      const imageUrl = swatch.dataset.imageUrl || swatch.getAttribute('href') || swatch.dataset.variantImage || swatch.dataset.src;
      if (imageUrl) swapCardImage(card, imageUrl);
      if (DEBUG) console.log('onPointerStartCapture: handled swatch tap', { imageUrl, card });
    } catch (err) {
      if (DEBUG) console.error('onPointerStartCapture error', err);
    }
  }

  // Capture-phase click handler to block card click navigation if we detected a swatch tap
  function onClickCapture(e) {
    try {
      if (!isMobile()) return;
      const swatch = e.target && e.target.closest ? e.target.closest('.color-swatch') : null;
      const card = swatch ? (swatch.closest('.card-wrapper') || swatch.closest('.card__inner') || swatch.closest('.card')) : null;
      // If either the click target is a swatch OR the card has the swatch-tapped flag, block it.
      const cardFromTarget = e.target && e.target.closest ? e.target.closest('.card__inner, .card-wrapper, .card') : null;
      const cardToCheck = card || cardFromTarget;
      const flag = cardToCheck && cardToCheck.dataset && cardToCheck.dataset._swatchTapped === 'true';

      if (swatch || flag) {
        try { e.preventDefault(); } catch (err) {}
        try { e.stopImmediatePropagation(); } catch (err) {}
        if (cardToCheck) {
          try { delete cardToCheck.dataset._swatchTapped; } catch (err) {}
        }
        if (DEBUG) console.log('onClickCapture: blocked card click due to swatch tap', { swatch, flag, card: cardToCheck });
      }
    } catch (err) {
      if (DEBUG) console.error('onClickCapture error', err);
    }
  }

  // Add listeners in capture phase. For touchstart we must set passive:false to allow preventDefault.
  try {
    document.addEventListener('pointerdown', onPointerStartCapture, { capture: true });
    document.addEventListener('touchstart', onPointerStartCapture, { capture: true, passive: false });
    document.addEventListener('click', onClickCapture, { capture: true });
    if (DEBUG) console.log('stop-swatch-mobile-redirect: listeners installed');
  } catch (err) {
    // Older browsers might not accept options object - fallback
    document.addEventListener('pointerdown', onPointerStartCapture, true);
    document.addEventListener('touchstart', onPointerStartCapture, true);
    document.addEventListener('click', onClickCapture, true);
    if (DEBUG) console.log('stop-swatch-mobile-redirect: fallback listeners installed');
  }

})();
